"use client";

// import React, { useEffect, useState } from "react";

import MobileNav from "./mobile-nav";
import Navigation from "./navigation";

export default function Header() {
  // Removed scroll state variables since we don't need them anymore
  // const [isVisible, setIsVisible] = useState(true);
  // const [lastScrollY, setLastScrollY] = useState(0);

  // Commented out entire scroll effect
  /* useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY < 10) {
        setIsVisible(true);
      } else if (currentScrollY > lastScrollY) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [lastScrollY]); */

  return (
    <header className="contain">
      <nav
        className={`
          flex justify-center items-center z-50 top-0 fixed contain layout
          transition-transform duration-300 bg-primary py-4
        `}
      >
        <div className="lg:hidden w-full">
          <MobileNav />
        </div>
        <div className="hidden lg:block lg:w-full">
          <Navigation />
        </div>
      </nav>
    </header>
  );
}
